import { useNavigate, useLocation } from 'react-router-dom';

/**
 * AuthTabs Component - Toggle entre Login e Cadastro
 *
 * @example
 * ```tsx
 * <AuthTabs />
 * ```
 */
export const AuthTabs = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isLogin = location.pathname === '/';
  const isCadastro = location.pathname === '/cadastro';

  return (
    <div className="flex gap-2 p-1.5 bg-[#1a1a1a] rounded-xl w-fit">
      <button
        onClick={() => navigate('/')}
        className={`
          px-8 py-3 rounded-lg font-semibold text-base
          transition-all duration-200
          ${isLogin
            ? 'bg-[#F4CC04] text-black'
            : 'bg-transparent text-[#CCCCCC] hover:text-white'
          }
        `}
      >
        Fazer login
      </button>
      <button
        onClick={() => navigate('/cadastro')}
        className={`
          px-8 py-3 rounded-lg font-semibold text-base
          transition-all duration-200
          ${isCadastro
            ? 'bg-[#F4CC04] text-black'
            : 'bg-transparent text-[#CCCCCC] hover:text-white'
          }
        `}
      >
        Cadastrar
      </button>
    </div>
  );
};
